import BaseDataObject from './BaseDataObject';
import Money from './Money';
import StakeHorsesWithoutMarks from './StakeHorsesWithoutMarks';

export default class Stake extends BaseDataObject {
  isDelayed() {
    return this.has('delayedAnswerUri');
  }

  getDelayedAnswerURI() {
    return this.getString('delayedAnswerUri');
  }

  getStake() {
    return this.getObject('stake', Money);
  }

  getBongFee() {
    return this.getFloat('bongFee', 0);
  }

  getReducedRows() {
    return this.getInteger('rows');
  }

  getUnreducedRows() {
    return this.getInteger('unreducedRows');
  }

  getNumberOfCoupons() {
    return this.getInteger('nrOfCoupons');
  }

  getNumberOfRows() {
    return this.getNumberOf('percentOfBets');
  }

  getNumberOfSystems() {
    return this.getFloat('nrOfSystems');
  }

  getRow(index) {
    return this.getObject('percentOfBets', StakeRow, index);
  }

  getPercentOfBets() {
    return this.data.percentOfBets || [];
  }

  getNrOfBets() {
    return this.data.nrOfBets || [];
  }

  getNrOfBetsRow(index) {
    return this.getObject('nrOfBets', NrOfBetsRow, index);
  }

  getDividend() {
    return this.getObject('dividend', StakeDividend);
  }

  setDividend(d) {
    return this.setObject('dividend', d);
  }

  getHorsesWithoutMarks() {
    return this.getObject('horsesWithoutMarks', StakeHorsesWithoutMarks);
  }

  getUserMessage() {
    return this.getString('userMessage');
  }

  isNotCalculated() {
    return this.getBoolean('notCalculated');
  }

  getStakeAmountBasedOnTurnoverAt() {
    return this.getDate('stakeAmountBasedOnTurnoverAt');
  }

  getOwnWinPercentageDistributionTimestamp() {
    return this.getDate('ownWinPercentageBetDistributionTimestamp');
  }

  getOwnWinPercentageDistribution() {
    return this.data.ownWinPercentageBetDistribution;
  }
}

class StakeRow extends BaseDataObject {
  constructor(data) {
    super(Array.isArray(data) ? { percentOfBets: data } : data);
  }

  getPercentOfBets(index) {
    return this.getFloatAt('percentOfBets', index);
  }
}

class NrOfBetsRow extends BaseDataObject {
  constructor(data) {
    super(Array.isArray(data) ? { nrOfBets: data } : data);
  }

  getNrOfBets(index) {
    return this.getIntegerAt('nrOfBets', index);
  }
}

class StakeDividend extends BaseDataObject {
  getNumberOfDistributionIntervals() {
    return this.getNumberOf('dividendDistribution');
  }

  getDistributionInterval(index) {
    return this.getObject(
      'dividendDistribution',
      StakeDividendDistributionInterval,
      index,
    );
  }

  getPredictedNumberOfWinners() {
    return this.getFloat('predictedNrOfWinners');
  }

  getPredictedOneErrorNumberOfWinners() {
    return this.getFloat('predictedOneErrorNrOfWinner');
  }

  getPredictedTwoErrorNumberOfWinners() {
    return this.getFloat('predictedTwoErrorNrOfWinner');
  }

  getPredictedDividend() {
    return this.getObject('predictedDividend', Money);
  }

  getPredictedOneErrorDividend() {
    return this.getObject('predictedOneErrorDividend', Money);
  }

  getPredictedTwoErrorDividend() {
    return this.getObject('predictedTwoErrorDividend', Money);
  }

  getPredictedSumOfStakes() {
    return this.getObject('predictedSumOfStakes', Money);
  }

  getPredictedSumOfStakesOneError() {
    return this.getObject('predictedSumOfStakesOneError', Money);
  }

  getPredictedSumOfStakesTwoError() {
    return this.getObject('predictedSumOfStakesTwoError', Money);
  }

  getNumberOfWinningRows() {
    return this.getFloatArray('nrOfWinningRows');
  }
}

class StakeDividendDistributionInterval extends BaseDataObject {
  getLabelID() {
    return this.getString('labelId');
  }

  getNumberOfRows() {
    return this.getInteger('numRows');
  }

  getPercent() {
    return this.getFloat('percent');
  }
}
